import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { SchemaService } from 'src/app/shared/symptoms/services/schema/schema.service';
import { PreopReportBranchSchema } from './../pre-op-report.component';

@Component({
  selector: 'csi-pre-op-report-branch',
  templateUrl: './pre-op-report-branch.component.html',
  styleUrls: ['./pre-op-report-branch.component.css']
})
export class PreOpReportBranchComponent implements OnInit, OnChanges {
  @Input() schema: PreopReportBranchSchema;
  @Input() key: string;
  @Input() formGroup: FormGroup;
  @Input() signKeys: string[];

  public schemaKeys: string[];

  public translatedValues: { [key: string]: { right: string; left: string } } = {};

  constructor(
    public schemaService: SchemaService,
    private translocoService: TranslocoService,
    private titleCasePipe: TitleCasePipe
  ) {}

  ngOnInit() {
    this.schemaKeys = Object.keys(this.schema);
    this.computeTranslatedValues();
  }

  ngOnChanges() {
    this.computeTranslatedValues();
  }

  private computeTranslatedValues() {
    const messages = this.schema[this.key].messagesAndTechnicianNotes || {};
    this.translatedValues = {};
    for (const [k, v] of Object.entries(messages)) {
      this.translatedValues[k] = {
        right: this.titleCaseAndTranslateValue(v.right),
        left: this.titleCaseAndTranslateValue(v.left)
      };
    }
  }

  titleCaseAndTranslateValue(value: any): string {
    if (value === null || value === undefined) {
      return 'N/A';
    }

    if (typeof value === 'number') {
      return value.toString();
    }

    if (typeof value === 'string' && !isNaN(Number(value))) {
      return value;
    }

    const translation = this.translocoService.translate(value);
    if (translation !== value) {
      return translation;
    }

    return typeof value === 'string' ? this.titleCasePipe.transform(value) : value;
  }
}
